import { PolygraphyProductFormat } from '../../../../../services/exports/Constants';

export default {
  form: {
    name: {
      label: "Nommer ce travail d'impression",
      placeholder: 'Flyer A5 - promotion spéciale',
    },
    format: {
      label: 'Type de produit',
      placeholder: 'Sélectionner le type de produit',
      options: {
        [PolygraphyProductFormat.FlyerA5]: 'Flyer (A5)',
        [PolygraphyProductFormat.FlyerA6]: 'Flyer (A6)',
        [PolygraphyProductFormat.Sticker60x60]: 'Autocollant (60x60mm)',
        [PolygraphyProductFormat.DoorStickerA5]: 'Autocollant de porte (30x30cm)',
      },
    },
    file: {
      label: 'Fichier',
    },
  },
  buttons: {
    upload: 'Cliquer ou glisser pour importer un fichier',
    save: 'Enregistrer',
  },
  toasts: {
    changes_got_saved: 'Modifications enregistrées !',
  },
};
